import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseService } from '../../core';
import { CertificadoResponse } from 'app/shared/models/ei-models';

@Injectable({ providedIn: 'root' })
export class CertificadoService extends BaseService {
  private certificadoEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Certificado/`;

  constructor(private http: HttpClient) {
    super();
  }

  listarCertificadosUsuario(usuarioId: number): Observable<CertificadoResponse[]> {
    return this.http.get<CertificadoResponse[]>(
      `${this.certificadoEndpoint}Usuario/${usuarioId}`,
      { headers: this.getHeader(true) }
    );
  }

  downloadCertificado(certificadoId: number): Observable<Blob> {
    return this.http.get(
      `${this.certificadoEndpoint}Download/${certificadoId}`,
      { headers: this.getHeader(true), responseType: 'blob' }
    );
  }
}
